export const environment = {
  production: true,
  baseUrl: 'https://devapi.moovement.co:443',
  platform: 'web',
  topic: "co.moovement.MoovementApp",
  appName: 'Moovement Web Portal'
};
